import React from 'react'
import { useHistory } from 'react-router-dom'

// SVG Icons
import { ReactComponent as Collapsedlogo } from '../assets/svg/US-collapsed.svg'
import { ReactComponent as CollapsedEarlylogo } from '../assets/svg/US-Early-collapsed.svg'
import { ReactComponent as FullLogo } from '../assets/svg/US-full.svg'
import { ReactComponent as EarlyFullLogo } from '../assets/svg/US-Early-full.svg'

// Both marks stay mounted and stacked in a fixed-height box; which one shows is decided
// by the sidebar's data-state in CSS, so the swap is a crossfade instead of a cut and the
// header never changes height. The small mark sits in the rail slot, the wordmark is
// centred on the full panel width.
const SidebarLogo = ({ primaryUI }) => {
    const history = useHistory()

    const handleLogoClick = () => {
        history.push('/dashboard')
    }

    return (
        <div className="sb-logo mt-6">
            <div className="sb-logo__mark sb-rail-slot sb-conceal" onClick={handleLogoClick}>
                {!primaryUI ? <Collapsedlogo /> : <CollapsedEarlylogo />}
            </div>
            <div className="sb-logo__full" onClick={handleLogoClick}>
                <span className="sb-logo__wordmark sb-reveal">{!primaryUI ? <FullLogo /> : <EarlyFullLogo />}</span>
            </div>
        </div>
    )
}

export default SidebarLogo
